<!--The main objetive for this component is to make it easy to create an uniform style for the tabs-->
<div class="header">
    <span class="underline--magical">{{parentData}}</span> 
</div>
